import { G2S } from '../g2s';
import * as api from '../api';

export class AccountService {
    confirm(token: string): Promise<api.User> {
        return new Promise<api.User>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Confirm',
                    {
                        token: token
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.User>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getRefundInfo(locale: string, reservationPublicId?: string): Promise<api.RefundInfo> {
        return new Promise<api.RefundInfo>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/getclientformtext',
                    {
                        Locale: locale,
                        ReservationPublicId: reservationPublicId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.RefundInfo>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getRefundInfoWithWriteUs(locale: string, reservationPublicId?: string): Promise<api.RefundInfo> {
        return new Promise<api.RefundInfo>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/getclientformtextwithwriteus',
                    {
                        locale: locale,
                        reservationId: reservationPublicId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.RefundInfo>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getSupportText(locale: string): Promise<api.AutovoidSupportText> {
        return new Promise<api.AutovoidSupportText>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/getsupportadvisetext',
                    {
                        Locale: locale
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.AutovoidSupportText>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getProcessStartedText(locale: string): Promise<api.AutovoidStartedText> {
        return new Promise<api.AutovoidStartedText>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/getprocessstartedformtext',
                    {
                        Locale: locale
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.AutovoidStartedText>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    checkVoidAvailability(reservationId: string): Promise<api.CheckAutoVoidAvailable> {
        return new Promise<api.CheckAutoVoidAvailable>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/checkavailability',
                    {
                        reservationId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.CheckAutoVoidAvailable>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    createVoid(reservationPublicId: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/Create',
                    {
                        reservationPublicId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function () {
                    resolve(true);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    createVoidSupport(reservationId: string, email?: string, description?: string | null): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Voids/Create',
                    {
                        reservationId,
                        email,
                        description
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function () {
                    resolve(true);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
    
    confirmEmail(token: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Email/Confirm',
                    {
                        token: token
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    deleteStart(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Delete/Start',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    deleteConfirm(token: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Delete/Confirm',
                    {
                        token: token
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    exists(emailOrPhone: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Exists',
                    {
                        emailOrPhone: emailOrPhone
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    forgottenPassword(email: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/ForgottenPassword',
                    {
                        email: email
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getBonusStatus(): Promise<api.BonusStatus> {
        return new Promise<api.BonusStatus>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/BonusStatus',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.BonusStatus>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getCurrentUser(): Promise<api.User> {
        return new Promise<api.User>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/CurrentUser',
                    null,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.User>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getCurrentUserAccount(): Promise<api.UserAccount> {
        return new Promise<api.UserAccount>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/CurrentUserAccount',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.UserAccount>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getCurrentUserWithProfile(): Promise<api.UserWithProfile> {
        return new Promise<api.UserWithProfile>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/CurrentUserWithProfile',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.UserWithProfile>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getCurrentUserWithBonuses(bookingSessionId?: number): Promise<api.UserWithBonuses> {
        return new Promise<api.UserWithBonuses>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/CurrentUserWithBonuses',
                    {
                        bookingSessionId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.UserWithBonuses>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    ordersList(): Promise<api.ReservationStatusResult[]> {
        return new Promise<api.ReservationStatusResult[]>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Orders/List',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.ReservationStatusResult[]>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    ordersExists(reservationId: string): Promise<api.OrdersExists> {
        return new Promise<api.OrdersExists>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Orders/Exists',
                    {
                        reservationId
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.OrdersExists>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    GetActiveReservationPublicId(): Promise<api.ActiveReservationPublicId> {
        return new Promise<any>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/GetActiveReservationPublicId',
                    {},
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) { 
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    registration(email: string, password: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/Registration',
                    {
                        email: email,
                        password: password
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    setPassword(token: string, password: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/SetPassword',
                    {
                        token: token,
                        password: password
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    signIn(emailOrPhone: string, password: string): Promise<api.User> {
        return new Promise<api.User>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/SignIn',
                    {
                        emailOrPhone: emailOrPhone,
                        password: password
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.User>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    signOut(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/SignOut',
                    null,
                    {
                        withCredentials: true
                    }
                )
                .then(function () {
                    resolve(true);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    updateEmail(email: string, currentPassword: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/UpdateEmail',
                    {
                        email: email,
                        currentPassword: currentPassword
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    updatePassword(newPassword: string, currentPassword: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/UpdatePassword',
                    {
                        currentPassword: currentPassword,
                        newPassword: newPassword
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    updatePhone(phone: string, currentPassword: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/UpdatePhone',
                    {
                        phone: phone,
                        currentPassword: currentPassword
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    updateProfile(user: api.User): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    '/api/Account/UpdateProfile',
                    {
                        user: user
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    sendOneTimePassword(email: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Account/SendOneTimePassword',
                    {
                        email: email
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function () {
                    resolve(true);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    signInByOneTimePassword(email: string, oneTimePassword: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            G2S.$http
                .post(
                    'api/Account/SignInByOneTimePassword',
                    {
                        email: email,
                        oneTimePassword: oneTimePassword
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<boolean>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

}
